import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToHash = ({headerRef}) => {
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        // Calculate the absolute top position of the element relative to the document
        const headerOffset = headerRef.current ? headerRef.current.offsetHeight : 0;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const topPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [location, headerRef]); // Run the effect whenever the location changes

  return null;
};

export default ScrollToHash;
